import { Container, Grid } from '@chakra-ui/react';

import { GridWrapperProps } from './grid-wrapper.props';

export const GridWrapper = ({ children, ...rest }: GridWrapperProps): JSX.Element => {
    return (
        <Container
            maxWidth={'containerWidth'}
            px={{
                base: 'gutterWidth',
                md: 'gutterWidthDesktop',
            }}
            as={Grid}
            rowGap={'gutterHeight'}
            columnGap={{ base: 'gutterWidth', md: 'gutterWidthDesktop' }}
            gridTemplateColumns={{
                base: 'repeat(4, 1fr)',
                md: 'repeat(16, 1fr)',
            }}
            {...rest}
        >
            {children}
        </Container>
    );
};
